import React, { PureComponent } from 'react';
import './index.module.less';

export default class Input extends PureComponent {
  constructor() {
    super();
    this.state = {
      isFocus: false,
    };
    this.inputRef = null;
  }

  handleFocus = e => {
    this.setState({ isFocus: true });
    this.props.onFocus && this.props.onFocus(e);
  };

  handleBlur = e => {
    this.setState({ isFocus: false });
    this.props.onBlur && this.props.onBlur(e);
  };

  componentDidMount() {
    const { value = '' } = this.props;
    if (this.props.autofocus) {
      this.inputRef.focus();
      this.inputRef.selectionStart = value.length;
      this.inputRef.selectionEnd = value.length;
    } else {
      this.inputRef.blur();
    }
  }

  getInputRef = node => {
    this.inputRef = node;
  };

  handleClear = e => {
    this.props.onClear();
    e.preventDefault();
  };

  getInnerInputNode({ type, value, placeholder, onChange, onComposition }) {
    return (
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onCompositionStart={onComposition}
        onCompositionUpdate={onComposition}
        onCompositionEnd={onComposition}
        ref={this.getInputRef}
      />
    );
  }

  getInputNode(type, innerInputNode) {
    if (type === 'search') {
      return <form action="#">{innerInputNode}</form>;
    } else {
      return innerInputNode;
    }
  }

  render() {
    const { children, type = 'text', style = {}, value = '', onClear = null } = this.props;
    const showClear = onClear && this.state.isFocus && value;
    return (
      <div styleName="input-wrap" style={{ ...style }}>
        {this.getInputNode(type, this.getInnerInputNode(this.props))}

        <div styleName="right-container">
          {showClear && <div styleName="icon-input-clear" onTouchStart={this.handleClear} />}
          {children}
        </div>
      </div>
    );
  }
}
